// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const slither_wing: PokeData = {
  "id": 988,
  "name": "slither-wing",
  "height": 32,
  "weight": 920,
  "base_experience": 285,
  "types": [
    PokeType.BUG,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "stomp",
    "thrash",
    "ember",
    "poison-powder",
    "stun-spore",
    "leech-life",
    "morning-sun",
    "superpower",
    "bulk-up",
    "bug-bite",
    "flame-charge",
    "low-sweep",
    "first-impression",
    "lunge",
    "dual-wingbeat"
  ],
  "moves": [
    "gust",
    "ember",
    "poison-powder",
    "stun-spore",
    "morning-sun",
    "superpower",
    "bulk-up",
    "bug-bite",
    "lunge",
    "heal-order",
    "meteor-assault",
    "signal-spam",
    "infest"
  ],
  "evolution_chain": {
    "id": 519,
    "item": null,
    "species": [
      {
        "name": "slither-wing",
        "order": 984,
        "types": [
          PokeType.BUG,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 116,
    "speed": 106,
    "ability_power": 177
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
